export default __webpack_public_path__ + "static/media/disponivel-na-play-store.a9a5a9b6.png";